import TabLinksVertical from './TabLinksVertical';

export default TabLinksVertical;
